import React from "react";
import NewSales from "../../components/custom/NewSales/Index";

const Index = () => {
  return (
    <div>
      <NewSales />
    </div>
  );
};

export default Index;
